import React, { useCallback, useEffect, useRef, useState } from "react";
import { useGetDataMutation } from "./dataApiSlice";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  getWorkbookProperty,
} from "./WorkbookSlice";
import { useSelector, useDispatch } from "react-redux";
import { Aside3FilterSidebar } from "./components/Aside3Components/Aside3FilterSidebar";
import { buildQuery } from "./utils/buildQuery";
import ChartsComp from "./components/Aside3Components/ChartsComp";
import { saveAs } from "file-saver";
import { useMyContext } from "../../MyContext";
import { getSheetControls } from "./WorkbookControllingSlice";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import VizardLoader from "./vizard/VizardLoader";
import AreYouSureModal from "./components/WorkbookComponets/AreYouSureModal";

export default function Aside3({
  currentSheet,
  SheeType,
  vizType: vizTypeFromWorkbook,
  isSheetInDashboard,
  dashboardAnimation,
  workbookType,
  widthHeightObject,
  isVizardLoading,
  isVizardError,
  vizardError,
}) {
  const { functionCalled, targetId } = useMyContext();
  const componentRef = useRef(null);

  // console.log(currentSheet);
  const { SheetName, Sheetid } = currentSheet;
  const Sheetindexvalue = Number(currentSheet.index);
  const rowKeysRef = useRef([]);
  const groupByKeysRef = useRef([]);
  const valueKeysRef = useRef([]);
  const toolTipKeysRef = useRef([]);

  const [getData, { data, isLoading, isSuccess, isError, error }] =
    useGetDataMutation();
  // useGetDataMutation({fixedCacheKey : Sheetid});

  const queryObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "query")
  );
  const filterArray = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "filters")
  );
  const sheetType = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "sheetType")
  );
  const rowLimit = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "rowLimit")
  );
  const offset = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "offset")
  );
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  const vizType = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "VizType")
  );
  const commonFilters = useSelector((state) =>
    getWorkbookProperty(state, "commonFilters")
  );
  const isAnimataionOff = useSelector(
    getSheetControls({ Sheetid, key: "isAnimataionOff" })
  );

  const sortProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "sort");
  });

  const queryDataControl = useSelector(
    getSheetControls({ Sheetid, key: "isPause" })
  );

  console.log(queryDataControl);

  const handleQueryData = useCallback(
    (queryBody) => {
      if (!queryDataControl) {
        console.log("query is running");
        getData(queryBody);
      }
    },
    [queryDataControl, getData]
  );

  useEffect(() => {
    const sheetDataSourceID = dataSourceID;
    console.log(sheetDataSourceID);
    if (queryObject) {
      const { queryBody, rowKeys, groupByKeys, valueKeys, toolTipKeys } =
        buildQuery(
          queryObject,
          dataSourceID,
          commonFilters,
          sortProperties,
          rowLimit,
          vizType,
          offset
        );
      console.log("queryBody is running", commonFilters);

      rowKeysRef.current = rowKeys;
      groupByKeysRef.current = groupByKeys;
      valueKeysRef.current = valueKeys;
      toolTipKeysRef.current = toolTipKeys;
      handleQueryData(queryBody);
    }
  }, [
    queryObject,
    Sheetindexvalue,
    commonFilters,
    dataSourceID,
    handleQueryData,
    sortProperties,
    rowLimit,
  ]);
  const [areYouSureModal, setAreYouSureModal] = useState(null);
  const rowKeys = rowKeysRef.current;
  const groupByKeys = groupByKeysRef.current;
  const valueKeys = valueKeysRef.current;
  const toolTipKeys = toolTipKeysRef.current;

  useEffect(() => {
    if (data && data.length === 500) {
      setAreYouSureModal(true);
    } else {
      setAreYouSureModal(null);
    }
  }, [data]);
  console.log(data && data.length);
  let vizContent;
  if (isVizardError) {
    console.log(vizardError);
    vizContent = vizContent = (
      <main className="text-red-500 font-medium">
        {SheetName}: {vizardError?.["data"]?.["message"] || "An error occurred"}
      </main>
    );
  }
  if (isLoading) {
    vizContent = (
      <main className="w-full h-full">
        {SheetName} : <LoadingIndicator />
      </main>
    );
  } else if (isError) {
    vizContent = (
      <main className="text-red-500 font-medium">
        {SheetName}: {error?.data?.message || "An error occurred"}
      </main>
    );
  } else if (isSuccess) {
    console.log("success");
    vizContent = (
      <ChartsComp
        {...{
          Sheetid,
          data,
          rowKeys,
          groupByKeys,
          valueKeys,
          toolTipKeys,
          vizType,
          sortProperties,
          isSheetInDashboard,
          isAnimataionOff: isSheetInDashboard
            ? dashboardAnimation
            : isAnimataionOff,
          dataSourceID,
          filters: queryObject.filters,
          commonFilters,
          widthHeightObject,
          rowLimit,
          offset: offset ?? 0,
        }}
      />
    );
  }
  if (isVizardLoading) {
    vizContent = <VizardLoader />;
  }
  const downloadDataAsCSV = (data) => {
    if (!data || data.length === 0) return;

    const keys = Object.keys(data[0]);
    const csvContent = [
      keys.join(","), // Header row
      ...data.map((row) =>
        keys
          .map((key) => (row[key] !== undefined ? `"${row[key]}"` : ""))
          .join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `exported-data-${Date.now()}.csv`);
  };

  useEffect(() => {
    if (functionCalled && targetId === Sheetid && data) {
      downloadDataAsCSV(data);
    }
  }, [functionCalled, data]);

  const isAnyVisibleFilterTrue =
    filterArray !== undefined && filterArray.some((item) => item.visibleFilter);

  console.log(isSheetInDashboard);
  console.log(isAnyVisibleFilterTrue);
  return (
    <main
      className={`w-full flex items-center justify-between ${
        ["simpleTable", "table"].includes(vizType) &&
        workbookType === "published"
          ? "h-[90%]"
          : "h-full"
      }`}
    >
      <div
        ref={componentRef}
        className={`${
          ["simpleTable", "table"].includes(vizType)
            ? isAnyVisibleFilterTrue
              ? isSheetInDashboard
                ? "w-full flex flex-col"
                : "w-[85%] flex flex-col"
              : "w-full flex flex-col"
            : "w-full flex"
        } h-full items-start justify-between p-[2px] bg-white gap-0`}
      >
        {vizContent}
      </div>
      {isAnyVisibleFilterTrue && !isSheetInDashboard ? (
        <div
          className={`relative right-0 h-full ${
            ["simpleTable", "table"].includes(vizType) ? "w-[15%]" : "w-[12vw]"
          }`}
        >
          {sheetType === "chart" && (
            <Aside3FilterSidebar
              Sheetid={Sheetid}
              isFilterVisibleInDashboard={false}
              filterArray={filterArray}
              commonFilters={commonFilters}
            />
          )}
        </div>
      ) : null}
      {isSheetInDashboard ? null : areYouSureModal ? (
        <AreYouSureModal
          message={"You Have Reached The Data Limit Please Apply Filters"}
          closeModal={() => setAreYouSureModal(null)}
          okayButton={() => setAreYouSureModal(null)}
          modalType={"warning"}
        />
      ) : null}
    </main>
  );
}
